import { render, staticRenderFns } from "./information.vue?vue&type=template&id=2332b533&"
import script from "./information.vue?vue&type=script&lang=ts&"
export * from "./information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports